// Usage: This Block is made to be used with the Headlines
// Richtext etc, so we can align the text accordingly

import * as React from 'react';
import {
  NODE_PARAGRAPH, render, MARK_LINK,
} from 'storyblok-rich-text-react-renderer';
import SplitPane from '../split-pane';
import FancyTitle from '../fancy-title';
import LinkResolver from '../../helpers/link-resolver';
import StoryblokImage from './storyblok-image';
import { storyblokEditable } from 'gatsby-source-storyblok';

function ParagraphComponent(children) {
  return (
    <p className="first-of-type:mt-0 last-of-type:mb-0">
      {children}
    </p>
  );
}

export default function ServiceStepRows({ blok, stepImage }) {
  const image = blok.image || stepImage;
  if (!blok.blocks.length) {
    return null;
  }
  return (
    <div {...storyblokEditable(blok)}>
      <div className="px-4 lg:px-16">
        <SplitPane
          items="start"
          className="pb-24 items-center"
          leftWidth="lg:w-1/2"
          rightWidth="lg:w-1/2 -order-1 md:order-2"
          left={(
            <div className="py-3 w-full">
              {blok.blocks.map((step, i) => (
                <div className="flex py-4" key={`d-${step.title}`}>
                  <div className="text-center pr-6">
                    <div className="rounded-full !w-[60px] !h-[60px] flex justify-center items-center bg-latori-green-dark text-white">
                      <span className="text-2xl">{String(i + 1).padStart(2, '0')}</span>
                    </div>
                    <div className="mt-6 mx-auto bg-latori-green w-[1px] h-[calc(100%-75px)]" />
                  </div>
                  <div className="pt-2 pr-2 md:pr-12 min-h-[300px]">
                    <FancyTitle
                      text={step.title}
                      fontSize="text-lg"
                      marginBottom="0"
                      className="fancy-title-small"
                      tag="h3"
                    />
                    {step.content
                      && (
                      <p className="pt-4 leading-6 service-step-content">
                          {render(step.content, {
                            markResolvers: {
                              [MARK_LINK]: LinkResolver,
                            },
                            nodeResolvers: {
                              [NODE_PARAGRAPH]: ParagraphComponent,
                            },
                          })}
                      </p>
                      )}

                  </div>
                </div>
              ))}
            </div>
          )}
          right={
            image && image?.name !== 'placeholder' && image && (
              <div>
                <StoryblokImage
                  alt={image.alt}
                  src={image}
                  className="w-full cover-image"
                />
              </div>
            )
          }
        />
      </div>
    </div>
  );
}
